// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageFunderList = () => import('@/modules/cash_advance/views/management/ManageFunderList')
const ManageFunderEdit = () => import('@/modules/cash_advance/views/management/ManageFunderEdit')
const ManageFunderFormPreview = () => import('@/modules/cash_advance/views/management/ManageFunderFormPreview')

var routes = [
    {
        path: '/cash-advance',
        redirect: '/cash-advance/funders/manage/list',
        name: 'CashAdvance',
        component: DefaultContainer,
        children: [
            {
                path: '/cash-advance/funders/manage/list',
                name: 'ManageFunderList',
                component: ManageFunderList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
                path: '/cash-advance/funders/manage/add',
                name: 'ManageFunderAdd',
                component: ManageFunderEdit,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
                path: '/cash-advance/funders/form-preview',
                name: 'ManageFunderFormPreview',
                component: ManageFunderFormPreview,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
                path: '/cash-advance/funders/manage/:funderId',
                name: 'ManageFunderEdit',
                component: ManageFunderEdit,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];

export default routes;
